function shouldShowAIComponentForStatus(status) {
  return status === 'pending' || status === 'completedNoResult' || status === 'failed';
}
export default shouldShowAIComponentForStatus;